import { useEffect } from 'react'
import { trackExperimentViewed } from '../events/trackExperimentViewed'
import { useExperiment } from './useExperiment'

// Called from Matrix's HeaderContent, which is the only place that knows which
// header won. The badge lives in the regular header and the promo one, so
// exposure has to cover both and skip BOGO and prcng-698_v1 — those render
// headers this experiment does not touch. Caller passes that verdict in.
export const useTrackExperimentViewed = (isBadgedHeader: boolean) => {
  const { isOn } = useExperiment()
  const shouldTrack = isOn && isBadgedHeader

  useEffect(() => {
    if (!shouldTrack) return

    trackExperimentViewed()
  }, [shouldTrack])
}
